import React, { useState } from "react";
import styled from "styled-components";
import * as XLSX from "xlsx";
import PrimaryButton from "../../helperComponents/PrimaryButton";
import LoadingSection from "../../helperComponents/LoadingSection";
import { serverLine } from "../../../controllers/network/serverLine";
import CustomLabelLarge from "../../customUiForCs/CustomLabelLarge";
import CustomLabel from "../../customUiForCs/CustomLabel";

const Container = styled.div`
  padding: 20px;
  background-color: var(--surface);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 62vw;
  border: 1px solid var(--borderDim);
`;

const Pre = styled.pre`
  border-radius: 10px;
  border: 1px solid var(--borderDim);
  padding: 20px;
  max-height: 800px;
  overflow-y: scroll;
  background-color: var(--surface);
`;
export default function ExcelUploaderForMigration({
  suggestedFileName,
  collectionName,
  path,
  title,
  message,
  dataNotRequired,
}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0]; // first sheet
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log("Parsed Data:", jsonData);
      setData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  if (loading)
    return (
      <Container>
        <CustomLabelLarge>{title}</CustomLabelLarge>
        <LoadingSection />
      </Container>
    );

  return (
    <Container>
      <CustomLabelLarge>{title}</CustomLabelLarge>
      {message ? (
        <CustomLabel>
          {message} ({suggestedFileName})
        </CustomLabel>
      ) : null}

      {suggestedFileName ? (
        <>
          <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
          <Pre>{JSON.stringify(data, null, 2)}</Pre>
        </>
      ) : null}

      <PrimaryButton onClick={upload}>Go</PrimaryButton>
    </Container>
  );

  async function upload() {
    try {
      if (!dataNotRequired) if (!data) return null;

      setLoading(true);
      await serverLine.post(path, { collectionName, rows: data });
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }
}
